<template>
  <v-app-bar class="dashboard-top-toolbar" dark app clipped-left flat>
    <v-app-bar-nav-icon @click="$emit('update:drawer', !drawer)" />
    <v-toolbar-title class="logo">
      <v-img
        v-if="bucketUrl"
        position="left center"
        height="60"
        contain
        width="350"
        :src="`${bucketUrl}/brand/logo-white.svg`"
      />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <avatar-menu v-if="name" />
    <v-progress-linear
      height="6"
      color="third"
      class="main-loader"
      :indeterminate="true"
      v-show="$store.state.loading"
    />
  </v-app-bar>
</template>
<script>
import AvatarMenu from '@/components/AvatarMenu'
import Auth from '@/modules/auth/models/Auth'
import { mapState } from 'vuex'

export default {
  name: 'DashboardTopToolbar',
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AvatarMenu
  },
  computed: {
    ...mapState(['bucketUrl']),
    name() {
      const authParents = Auth.query().first()

      if (!authParents) return ''

      return authParents.first_name ? authParents.first_name : authParents.email
    }
  }
}
</script>

<style lang="scss">
.dashboard-top-toolbar {
  z-index: 5;
  .v-toolbar__content {
    background: var(--v-primary-base);
  }
  .logo {
    @include breakpoint($xs) {
      margin-left: 0;
    }
  }
  .main-loader {
    position: absolute;
    bottom: -6px;
    margin: 0;
    left: 0;
    z-index: 5;

    * {
      z-index: 5 !important;
    }
  }
}
</style>
